import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Router } from '@angular/router';

import { BaseComponent } from '@src/app/commons/BaseComponent';
import { Constants } from '@src/app/commons/Constants';
import { PluginController } from '@src/app/commons/plugins/plugin-controller';
import { FdmPlugin } from '@src/app/commons/plugins/plugins';
import { PluginManagerService } from '@src/app/service/plugin-manager.service';
import { XsApplicationEventsService } from '../../events/application-events.service';
import { UiManagerService } from '../ui-manager.service';

@Component({
  selector: 'xs-widget-popover',
  templateUrl: './widget-popover.component.html'
})
export class XsWidgetPopoverComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  debug = false;

  // what plugin is in action
  plugin:FdmPlugin = null;
  
  // any item attached? (Transform, Scene, Annotation, etc.)
  item:any = null;
  
  // What popover controller is in control?
  @Input()
  controller:any;

  // What's the context? Who's calling the shots?
  @Input()
  context:any = this;
  

  // id for the popover panel itself
  id:string = null;

  // plugin controller
  @Input()
  pluginController:PluginController;



  // track state of hovering plugin menus
  hovers:any = {};

  // state and selected pre and actual items
  pre_selected_hover_item:any = null;
  selected_hover_item:any = null;



  constructor ( 

    // the three BaseComponent services
    public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, 

    // others we need
    public uiManager: UiManagerService,
    public applicationEvents:XsApplicationEventsService, 
    public pluginManager: PluginManagerService

  ) { super(router, snackBar, dialog); if ( this.debug ) { console.log('PopoverCOMPONENT %c [dunnoyet] %c CONSTRUCT', Constants._pink, Constants._pink); } }

  // look for changes to the @input variables
  ngOnChanges() {

    if ( this.debug ) { console.log('Popover %c [dunnoyet] %c ngChanges() ', Constants._pink, Constants._pink, this.pluginController, this.controller ); }

    if ( this.pluginController ) {
      this.pluginController.injectComponent(this);
    }

    // this controller is the popover controller (works as a bridge between the popower 
    // component and where it works from, for example layers.comp or map.comp, etc.)
    if ( this.controller ) {
      
      this.controller.injectComponent(this);

      // different contexts bring different plugin controllers
      if ( this.controller.pluginController ) {
        this.pluginController = this.controller.pluginController;
      }
    }
  }

  init() {

    // just use the component UUID as the popover id
    this.id = this.__ID.instance;

    if ( this.debug ) { console.log('Popover %c '+this.__ID.instance+' %c COMPONENT INIT', Constants._pink, Constants._pink ); }

  }

  clickPluginShortcut ( plugin:any, item:any, event:any = null ) {

    let me = this;

    if ( this.debug ) { console.log('Popover %c '+this.__ID.instance+' %c COMPONENT clickPluginShortcut', Constants._pink, Constants._pink, plugin.active, plugin, item.id ); }


    if ( plugin.active ) {

      if ( this.debug ) { console.log('Popover %c '+this.__ID.instance+' %c COMPONENT clickPluginShortcut ACTIVE', Constants._pink, Constants._pink, plugin ); }

      // already running
      this.activate(plugin, item, event);

    } else {

      if ( this.debug ) { console.log('Popover %c '+this.__ID.instance+' %c COMPONENT clickPluginShortcut NOT ACTIVE', Constants._pink, Constants._pink, plugin ); }

      // not running; start one up
      plugin.id = this.pluginController.create(plugin.name,null,item);

      if ( this.debug ) { console.log('Popover %c '+this.__ID.instance+' %c COMPONENT clickPluginShortcut CREATED', Constants._pink, Constants._pink, plugin ); }

      setTimeout( () => { me.activate(plugin, item, event); }, 500 );

    }
  }

  // activate the popover

  activate ( plugin:any, item:any, event:any = null ) {

    if ( this.debug ) { console.log('PopoverCOMPONENT %c '+this.__ID.instance+' %c activate', Constants._pink, Constants._pink); }

    let p = this.pluginManager.get(plugin.id);

    this.item = item;
    this.plugin = p;

    // let find = ('plugin-ui-' + plugin.id).trim();
    // let box = event.srcElement;

    let pop = document.getElementById(this.id+'pop');
    console.log('## pop', pop, event, this.plugin.meta );

    if ( pop && event && event.clientY ) {

      let y:number = (event.clientY + 15);
      // let pos:number = (document.documentElement.scrollTop || document.body.scrollTop) + document.documentElement.offsetHeight;
      let max:number = document.documentElement.scrollHeight;

      if ( max - y < 330 ) {
        y = max - 330;
      }
      pop.style.top = y + 'px';

      const rect = event.target.getBoundingClientRect();

      if ( this.plugin.meta.offsetX && this.plugin.meta.offsetX == 'context' ) {
        pop.style.left = rect.left + window.pageXOffset - 20 + 'px';
      }

      if ( this.plugin.meta.offsetY && this.plugin.meta.offsetY == 'context' ) {
        pop.style.top = rect.top + window.pageYOffset + 20 + 'px';
      }
      
      // give it some time for the sub-components to draw their content
      setTimeout( () => {

        // get the id of the UI plugin inner box, and adjust its max height so it doesn't cut below the bottom of the screen
        let box = document.getElementById( ('plugin-ui-' + plugin.id ).trim() );
        if ( box ) {
          box.style.maxHeight =  (max - y) - 50 + 'px';
        }
        // console.log('@@@', y, pos, max, (max - y) - 50, find );

      }, 100 );
    }

  }

  // deactivate / close the popover

  close() {
    
    this.item = null;
    this.plugin = null;

    if ( this.debug ) { console.log('popover %c '+this.__ID.instance+' %c close', Constants._pink, Constants._pink, this.item, this.plugin ); }

  }




  // all mouse over, hover and pop stuff

  mouseHoverClick ( inp:any, $event:any = null ) {
    this.pre_selected_hover_item = inp;
    this.mouseHoverForReal ( inp, $event );
  }

  // mousehover() is debouncing mousehoverforreal()
  mouseHover (  inp:any, $event:any = null ) {
    this.pre_selected_hover_item = inp;
    let me = this;
    setTimeout ( () => {
      me.mouseHoverForReal ( inp, $event );
    }, 800 );
  }

  // ok, the preselected item is still there, so make it a proper hover
  mouseHoverForReal ( inp:any, $event:any = null ) {

    if ( this.debug ) { console.log('PopoverController %c '+this.__ID.instance+' %c real', Constants._pink, Constants._pink ,inp,$event); }

    if ( this.pre_selected_hover_item ) {
      this.pre_selected_hover_item = null;
      this.selected_hover_item = inp;
      let id = inp.id;
      // console.log('hover real', id, inp );
  
      if ( ! this.hovers[id] ) {
        this.hovers[id] = {
          hovering:false
        };
      }
      if ( this.hovers[id].hovering ) {
        return;
      }
      this.hovers[id].hovering = true;

      // find the element where the action started
      // let find = document.getElementById('plugin-hover-for-'+id);

      let find = $event.srcElement;
      let pop = document.getElementById(this.id+'hover');

      if ( this.debug ) { console.log('PopoverController %c '+this.__ID.instance+' %c hover', Constants._pink, Constants._pink, this.id, find, pop ); }

      if ( find && pop ) {
        let pos = find.getBoundingClientRect();
        // let markerpos = this.marker.getBoundingClientRect();
        pop.style.top = pos.top - 8 + 'px';
        pop.style.left = pos.left - 8 + 'px';

        if ( this.debug ) { console.log('PopoverController %c '+this.__ID.instance+' %c hover style', Constants._pink, Constants._pink, pos, pop.style.top, pop.style.left ); }
        
      }
    }
  }

  // leaving the icon means kill the preselected hover to go through (mouse moved on)
  mouseLeaveIcon ( inp:any = null, $event:any = null ) {
    this.pre_selected_hover_item = null;
  }

  // this leave is leaving the popover menu
  mouseLeave( inp:any ) {
    if ( inp ) {
      let id = inp.id;
      // console.log('leave', id, inp );
      if ( this.hovers[id] && this.hovers[id].hovering ) {
        this.hovers[id].hovering = false;
        let pop = document.getElementById(this.id+'hover');
        if ( pop ) {
          // move the popover out of sight
          pop.style.top = '-101px';
          pop.style.left = '-101px';
        }
        // console.log('leave',inp);
      }
      this.selected_hover_item = null;
      this.pre_selected_hover_item = null;
    }
  }

  clickedPluginsHover ( name:string = null, inp:any = null, event:any = null ) {
    let me = this;
    let thisone = this.selected_hover_item;
    if ( inp ) {
      let newid = this.pluginController.create(name,null,inp);
      setTimeout ( () => {
        let plugin = me.pluginController.getById(newid);
        this.activate(plugin, thisone, event );
      }, 100 );
    }
    if ( this.selected_hover_item ) {
      this.mouseLeave ( this.selected_hover_item );
    }
  }

}
